{
  "$id": "module://role-mapping",
  "$schema": "wealthlane://schemas/domain",
  "title": "Role Mapping",
  "type": "object",
  "properties": {
    "destinationRoleId": {
      "type": "string",
      "title": "Mapped Role",
      "widget": "select",
      "actionId": "FETCH_ROLE_MAPPING_SELF_ROLES",
      "required": true,
      "noBlank": true
    },
    "selectedRoleMappingItems": {
      "type": "array",
      "title": "Source mappings",
      "widget": "hidden"
    }
  }
}
